import {
  baseGeneratedApi as api,
  type PostRelationshipsQueryApiResponse,
  type PostRelationshipsQueryApiArg
} from './generated/relationshipsApi'

const enhancedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRelationships: build.query<PostRelationshipsQueryApiResponse, PostRelationshipsQueryApiArg>({
      query: (queryArg) => ({
        url: '/relationships/query',
        method: 'POST',
        body: queryArg.serviceAuthorisationDomainModelsFiltersAuthRelationshipFilter,
      }),
      providesTags: ['Relationship']
    })
  })
})

export { enhancedRtkApi as baseApi }

export const {
  useGetRelationshipsQuery
} = enhancedRtkApi
